import { atom } from "jotai";
import { PlatformType } from "@/entities/Company";

export const selectedPlatformTypeAtom = atom<PlatformType>(
    PlatformType.ACCOUTING,
);
